import { Check, X, Minus } from "lucide-react";

const FEATURES = [
  { label: "3-Student Real-Time Combine Study", chatbot: "x", video: "x", smartguru: "y" },
  { label: "Pure Socratic method — guides you to the answer, never gives it away", chatbot: "x", video: "x", smartguru: "y" },
  { label: "Adaptive Mastery Engine — finds the exact misconception behind a wrong answer", chatbot: "x", video: "x", smartguru: "y" },
  { label: "Hybrid voice engine — talks & listens with dual OpenAI + ElevenLabs voices", chatbot: "m", video: "x", smartguru: "y" },
  { label: "Reads a photo of your handwritten homework", chatbot: "x", video: "x", smartguru: "y" },
  { label: "Built specifically for the CBSE Class 5-9 Math & Science syllabus", chatbot: "x", video: "m", smartguru: "y" },
  { label: "Parent progress dashboard included", chatbot: "x", video: "x", smartguru: "y" },
  { label: "Available 24/7, infinite patience", chatbot: "y", video: "y", smartguru: "y" },
];

function Mark({ state, dark }) {
  if (state === "y") return <Check className={`shrink-0 ${dark ? "text-[#A3E86A]" : "text-[#5FA82E]"}`} size={17} data-testid="compare-mark-yes" />;
  if (state === "m") return <Minus className="text-secondary shrink-0" size={17} data-testid="compare-mark-partial" />;
  return <X className={`shrink-0 ${dark ? "text-slate-500" : "text-slate-300"}`} size={17} data-testid="compare-mark-no" />;
}

function Column({ title, subtitle, rowKey, elevated }) {
  return (
    <div
      data-testid={`compare-column-${rowKey}`}
      className={
        elevated
          ? "relative bg-gradient-to-b from-[#4F4CB9] via-[#463696] to-[#241B4A] text-white rounded-3xl p-6 sm:p-8 shadow-2xl ring-2 ring-[#9A3DB2] shadow-[0_0_30px_rgba(154,61,178,0.35)] md:-translate-y-3 z-10 flex flex-col overflow-hidden"
          : "relative bg-white rounded-3xl p-6 sm:p-8 border border-slate-200 shadow-sm flex flex-col text-slate-700"
      }
    >
      <p className={`text-xs font-bold uppercase tracking-widest ${elevated ? "text-[#E8B8F5]" : "text-muted-foreground"}`}>{subtitle}</p>
      <h3 className={`font-heading font-bold text-xl mt-1 mb-6 ${elevated ? "text-white" : "text-slate-900"}`}>{title}</h3>
      <ul className="space-y-4 flex-1">
        {FEATURES.map((f, i) => (
          <li key={i} data-testid={`compare-row-${rowKey}-${i}`} className="flex items-start gap-2.5 text-sm">
            <Mark state={f[rowKey]} dark={elevated} />
            <span className={elevated ? "text-slate-100" : "text-slate-600"}>
              {f.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function LandingComparison() {
  return (
    <section className="py-10 sm:py-16 bg-sky-50/40 border-b border-sky-100/50" data-testid="landing-comparison-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-14">
        <p className="text-xs font-bold uppercase tracking-widest text-primary">How SmartGuru Compares</p>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl mt-2">Not another chatbot or video library.</h2>
        <p className="text-muted-foreground mt-3">Most tools available today either just answer questions or play a pre-recorded lesson. SmartGuru actually teaches — like a real tutor sitting next to your child.</p>
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 items-stretch" data-testid="landing-comparison-columns">
        <Column rowKey="chatbot" title="Generic AI Chatbot" subtitle="Any chatbot app" />
        <Column rowKey="video" title="Recorded Video Course" subtitle="Pre-recorded lessons" />
        <Column rowKey="smartguru" title="SmartGuru.io" subtitle="Your AI Super-Teacher" elevated />
      </div>
    </section>
  );
}
